import * as z from "zod";

export const fileSchema = z.object({
  fileName: z.string().optional(),
  fileDataAsBase64: z.string().optional(),
  fileUrl: z.string().optional(),
  localFileUrl: z.string().optional(),
  isVideo: z.boolean().optional(),
});

export const locationSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});
